import animation from './Animation.module.css';

type SkeletonRectangleProps = {
    width?: string;
    height?: string;
};

export const SkeletonRectangle = ({ width = '100%', height = '20px' }: SkeletonRectangleProps) => {
    return (
        // eslint-disable-next-line react/forbid-dom-props
        <div style={{ width, height }} className={animation.skeleton} />
    );
};
